import { createSelector } from "reselect";

import { selectAllChangelogEntries } from "./changelog.slice";
import type { ChangelogState } from "./changelog.state";

export const selectChangelogSlice = (state: ChangelogState) => state.changelog;

export const selectLatestChangelogEntry = createSelector([selectAllChangelogEntries], (entries) => {
	return (
		entries
			.filter((entry) => entry.platformsList.isNotEmpty())
			.sort((a, b) => (b.publishDate?.seconds ?? 0) - (a.publishDate?.seconds ?? 0))[0] ??
		null
	);
});

export const selectChangelogAsyncStatus = createSelector(
	[selectChangelogSlice],
	(changelog) => changelog.status,
);
